/* Joyful Neon — přepínání stavů hlavičky podle scrollu.
 *
 * Třída na <html>:
 *   jn-head--over   hlavička leží nad hero fotkou -> průhledná
 *   (bez třídy)     hlavička má plné pozadí
 *
 * Pozor na dvě věci, které se tu chovají nestandardně:
 *  - scroll události na window se nespouštějí,
 *  - IntersectionObserver po úvodním callbacku mlčí.
 * Obojí ověřeno i v reálném prohlížeči, ne jen v automatizaci. Proto si
 * pozici čteme sami v requestAnimationFrame smyčce — ta na ničem z toho
 * nezávisí. Porovnání dvou čísel na snímek je zanedbatelné a smyčka se
 * zastaví, když je záložka na pozadí.
 *
 * Výchozí stav v CSS je ZAPLNĚNÝ, takže případné selhání téhle logiky
 * znamená jen to, že hlavička bude plná i nad fotkou — ne nečitelné menu.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('jn-calm');

  var header = document.getElementById('shopify-section-header-inline');
  var main = document.getElementById('MainContent');
  if (!header || !main) return;

  var threshold = 0;
  var isOver = null;
  var rafId = null;

  function measure() {
    var hero = main.firstElementChild;
    var h = hero ? hero.getBoundingClientRect().height : 0;
    /* Stránky bez velkého hero (kategorie, blog, obsah) mají plnou hlavičku
       pořád — není přes co být průhledná. */
    threshold = h >= 240 ? h - header.offsetHeight - 40 : -1;
  }

  function tick() {
    var over = threshold >= 0 && window.scrollY < threshold;
    if (over !== isOver) {
      isOver = over;
      root.classList.toggle('jn-head--over', over);
    }
    rafId = window.requestAnimationFrame(tick);
  }

  function start() {
    if (rafId === null) rafId = window.requestAnimationFrame(tick);
  }

  function stop() {
    if (rafId !== null) { window.cancelAnimationFrame(rafId); rafId = null; }
  }

  measure();
  start();

  /* Hero dostane skutečnou výšku až po načtení fotky. Spoléhat na load()
     nestačí — když se skript vyhodnotí až po něm, událost už nepřijde.
     ResizeObserver pokryje načtení obrázků, písem i změny rozvržení. */
  var hero = main.firstElementChild;
  if (hero && window.ResizeObserver) {
    new ResizeObserver(measure).observe(hero);
  }

  window.addEventListener('load', measure);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measure, 200);
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
})();
